module.exports = __webpack_public_path__ + "media/1x1/uz-ca892343.svg";